"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _stylesModule = _interopRequireDefault(require("@components/Layout/Container/styles.module.scss"));

var _scss = require("@scss");

var _excluded = ["children", "html", "className", "component", "onClick"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var GridBox = function GridBox(_ref) {
  var _getCssProp$split$map;

  var children = _ref.children,
      html = _ref.html,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$component = _ref.component,
      BaseComponent = _ref$component === void 0 ? 'div' : _ref$component,
      onClick = _ref.onClick,
      props = _objectWithoutProperties(_ref, _excluded);

  var orderClass = (_getCssProp$split$map = (0, _scss.getCssProp)(props, 'order').split(' ').map(function (cx) {
    return _stylesModule["default"][cx.trim()];
  })) !== null && _getCssProp$split$map !== void 0 ? _getCssProp$split$map : [];
  return /*#__PURE__*/_react["default"].createElement(BaseComponent, _extends({
    onClick: onClick !== null && onClick !== void 0 ? onClick : null,
    className: (0, _scss.cls)(_stylesModule["default"]['col-gutter'], orderClass, className)
  }, html ? {
    dangerouslySetInnerHTML: {
      __html: html
    }
  } : {}, props), children);
};

var _default = GridBox;
exports["default"] = _default;